import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import SessionStrip from "@/components/site/SessionStrip";
import WhyPLST from "@/components/site/WhyPLST";
import WhoFor from "@/components/site/WhoFor";
import Process from "@/components/site/Process";
import Services from "@/components/site/Services";
import VideoFeature from "@/components/site/VideoFeature";
import Team from "@/components/site/Team";
import Testimonials from "@/components/site/Testimonials";
import InsidePLST from "@/components/site/InsidePLST";
import FAQ from "@/components/site/FAQ";
import CTABand from "@/components/site/CTABand";
import Contact from "@/components/site/Contact";

export default function Home() {
  return (
    <div className="bg-[#F5F4EF] text-[#1E1E1E]" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <WhyPLST />
        <SessionStrip />
        <WhoFor />
        <Process />
        <Services />
        <VideoFeature />
        <Team />
        <Testimonials />
        <InsidePLST />
        <FAQ />
        <CTABand />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
